import { treatmentRuntimeApiUrl } from "../runtimeApiBase";
import { storeProgramAuthentication } from "./programAuthenticationStorage";

const HANDOFF_PATH = "/treatments/patient-portal-handoff/exchange/";

export const consumePatientPortalHandoff = async ({
  search = "",
  apiBaseUrl,
  replaceUrl = true,
} = {}) => {
  const params = new URLSearchParams(search);
  const portalHandoff = params.get("portal_handoff");
  if (!portalHandoff) return false;

  const body = {
    portal_handoff: portalHandoff,
    program_id: params.get("program_id"),
    custom_program_id: params.get("custom_program_id"),
    release_token: params.get("release_token"),
    release_version: params.get("release_version"),
  };
  const response = await fetch(treatmentRuntimeApiUrl(apiBaseUrl, HANDOFF_PATH), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(
      "Your secure Patient Portal handoff expired. Please start the treatment again from the Patient Portal.",
    );
    error.code = data.error || "patient_portal_handoff_invalid";
    throw error;
  }

  storeProgramAuthentication({
    accessToken: data.access_token,
    accessTokenExpiresIn: data.access_token_expires_in,
    patient: data.patient,
    profile: data.profile,
  });

  if (replaceUrl && typeof window !== "undefined") {
    const sanitized = new URL(window.location.href);
    sanitized.searchParams.delete("portal_handoff");
    window.history.replaceState({}, "", sanitized.toString());
  }
  return true;
};
